module.exports = {
      id: "icons:caret-down-usage",
      viewBox: "0 0 8 4",
      url: "/static/" + "sprites.9a613551d588b36f01fd88ce7dbef123.svg#icons:caret-down-usage",
      toString: function () {
        return this.url;
      }
    }